import { Head, Form } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, FieldGroup, FieldError, FieldLabel, FieldSet } from "@/components/ui/field";

export default function NewTeam() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const slugify = (input) => {
    return String(input)
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Head title="Create Team" />
      <Form action="/teams" method="POST" className="w-full max-w-[380px]">
        {({ data, errors }) => (
          <FieldSet>
            <FieldGroup>
              <Field data-invalid={!!errors.name}>
                <FieldLabel htmlFor="new-team-name">Your Team Name</FieldLabel>
                <Input id="new-team-name" name="name" placeholder="Dreamteam Inc." aria-invalid={!!errors.name} />
                <input type="hidden" name="timezone" value={timezone} />
                {errors.name && (<FieldError>{errors.name}</FieldError>)}
              </Field>

              <Field orientation="horizontal">
                <Button type="submit">Create</Button>
              </Field>
            </FieldGroup>
          </FieldSet>
        )}
      </Form>
    </div>
  );
}
